export const CATEGORIES = {
  event: { label: "Church Event", color: "#1D64B4", bg: "#EBF3FA" },
  wedding: { label: "Wedding", color: "#B45309", bg: "#FEF3C7" },
  dedication: { label: "Child Dedication", color: "#047857", bg: "#D1FAE5" },
  funeral: { label: "Funeral / Memorial", color: "#334155", bg: "#E2E8F0" },
  counseling: { label: "Pastoral Counseling", color: "#BE123C", bg: "#FFE4E6" },
  meeting: { label: "Staff Meeting", color: "#6D28D9", bg: "#EDE9FE" },
  worship: { label: "Worship Service", color: "#0369A1", bg: "#E0F2FE" },
};

export const TIMES = Array.from({ length: 33 }, (_, i) => {
  const mins = 6 * 60 + i * 30;
  const h = String(Math.floor(mins / 60)).padStart(2, "0");
  const m = String(mins % 60).padStart(2, "0");
  const h12 = ((Math.floor(mins / 60) + 11) % 12) + 1;
  return { value: `${h}:${m}`, label: `${h12}:${m} ${mins < 720 ? "AM" : "PM"}` };
});

export const timeLabel = (v) => TIMES.find((t) => t.value === v)?.label || v;
